import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import { useStores } from "_common/hooks";
import { observer } from "mobx-react-lite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCircleUser,
  faBell,
  faListCheck,
  faSliders,
  faHammer,
  faUser,
  faGear,
  faShield,
  faUserPlus,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useMutation } from "@tanstack/react-query";
import { AuthApi } from "states/api";
import i18next from "i18next";
import { NotificationManager } from "react-notifications";
import applicationIcon from "assets/icons/application.svg";
import chartIcon from "assets/icons/chart.svg";
import hotIcon from "assets/icons/hot-2.svg";
import btcIcon from "assets/icons/btcIcon.svg";
import downIcon from "assets/icons/downIcon.svg";
import icon5 from "assets/img/icon/icon-5.png";
import qrdownload from "assets/img/qrdownload.png";

const HeaderDesktop = observer(({ is_open, setMenuOpen }) => {
  const {
    authStore: { logo, general, authenticated, clear, user },
  } = useStores();

  const { mutate: onLogout } = useMutation(AuthApi.logout, {
    onSuccess: (res) => {
      clear();
    },
    onError: (error) => {
      clear();
      const errorMessage =
        i18next.t(error?.message) ?? i18next.t("action_failed_msg");
      NotificationManager.error(errorMessage);
    },
  });

  return (
    <header className="css-jmskxt">
      <Link to="/" className="css-1mvf8us">
        <img src={logo} className="css-1jgk2rg css-logo" alt="" />
        <div className="css-1tp5kus header-title">
          <div className="css-vurnku  f22 fw header-title">
            {general?.name_website}
          </div>
        </div>
      </Link>

      <div className="css-1tp5kus">
        <Link to="/" className="css-1smf7ma">
          <div className="css-vurnku">Trang chủ</div>
        </Link>
      </div>
      <div className="css-1tp5kus">
        <Link to="/market" className="css-1smf7ma">
          <div className="css-vurnku">Thị trường</div>
        </Link>
      </div>
      <div className="css-1tp5kus">
        <Link to="/trade" className="css-1smf7ma">
          <div className="css-vurnku">Giao dịch</div>
        </Link>
      </div>
      <div className="css-1tp5kus">
        <Link to="/issue" className="css-1smf7ma">
          <div className="css-vurnku">
            <img src={hotIcon} alt="" className="hot-2" />
            IEO
          </div>
        </Link>
      </div>
      <div className="css-1tp5kus">
        <Link to="/orepool" className="css-1smf7ma">
          <div className="css-vurnku">
            <img src={hotIcon} alt="" className="hot-2" />
            DeFi
          </div>
        </Link>
      </div>
      <div className="css-1tp5kus">
        <Link to="/member/notice" className="css-1smf7ma">
          <div className="css-vurnku">Trung tâm thông báo</div>
        </Link>
      </div>
      <div className="css-11y6cix" />
      <ul id="nav" className="nav !items-center">
        <div className="css-wu6zme !items-center">
          <div className="css-mu7imd">
            <Link to="/cskh">
              <div className="css-1smf7ma">
                <div className="css-15owl46" style={{ padding: "0px 5px;" }}>
                  <img src={icon5} alt="" style={{ width: "35px" }} />
                </div>
              </div>
            </Link>
          </div>
          {authenticated ? (
            <>
              <div className="css-mu7imd">
                <Link to="/board/wallet">
                  <div className="css-1smf7ma">
                    <div
                      className="css-15owl46"
                      style={{ padding: "0px 5px;" }}
                    >
                      <div className="css-vurnku">Ví tiền</div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="css-mu7imd">
                <div className="css-1smf7ma hover-dropdown">
                  <Link to="/member">
                    <div
                      className="css-15owl46"
                      style={{ padding: "0px 5px;" }}
                    >
                      <div className="css-vurnku">
                        <FontAwesomeIcon
                          icon={faCircleUser}
                          className="w-[20px] h-[20px]"
                        />
                      </div>
                    </div>
                  </Link>
                  <ul className="sub dropdown">
                    <div className="order_navlist !min-w-[220px] top-[35px] right-[60px]">
                      <li>
                        <div className="w-full h-[50px] leading-[50px] text-left py-[0] px-[15px]">
                          <span className="text-[16px] text-[#EAECEF] font-[900]">
                            {user?.username}
                          </span>
                          <span className="f12 fgreen">đã xác minh</span>
                        </div>
                      </li>
                      <li>
                        <a href="/member">
                          <div className="optionli">
                            <FontAwesomeIcon
                              icon={faUser}
                              className="!text-[18px] !text-[#00b897]"
                            />
                            <span className="text-[#EAECEF]">
                              Tổng tài khoản
                            </span>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href="/member/change-password">
                          <div className="optionli">
                            <FontAwesomeIcon
                              icon={faGear}
                              className="!text-[18px] !text-[#00b897]"
                            />
                            <span className="text-[#EAECEF]">
                              Cài đặt hệ thống bảo vệ
                            </span>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href="/member/kyc">
                          <div className="optionli">
                            <FontAwesomeIcon
                              icon={faShield}
                              className="!text-[18px] !text-[#00b897]"
                            />
                            <span className="text-[#EAECEF]">Xác thực</span>
                          </div>
                        </a>
                      </li>
                      <li>
                        <div
                          className="optionli border-t-[1px] border-[#f5f5f5]"
                          onClick={() => onLogout()}
                        >
                          <FontAwesomeIcon
                            icon={faRightFromBracket}
                            className="!text-[18px] !text-[#00b897]"
                          />
                          <span className="text-[#EAECEF]">Đăng xuất</span>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <div className="css-mu7imd">
                <Link to="/member/notice">
                  <div className="css-1smf7ma">
                    <div
                      className="css-15owl46"
                      style={{ padding: "0px 5px;" }}
                    >
                      <div className="css-vurnku">
                        <FontAwesomeIcon
                          icon={faBell}
                          className="w-[20px] h-[20px]"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </>
          ) : (
            <>
              <div className="css-mu7imd">
                <Link to="/auth/login">
                  <div className="css-1smf7ma">
                    <div
                      className="css-15owl46"
                      style={{ padding: "0px 5px;" }}
                    >
                      <div className="css-vurnku">Đăng nhập</div>
                    </div>
                  </div>
                </Link>
              </div>
              <div
                className="css-mu7imd"
                style={{ border: "2px solid #00b897", borderRadius: "5px" }}
              >
                <Link to="/auth/register">
                  <div className="css-1smf7ma">
                    <div
                      className="css-15owl46"
                      style={{ padding: "0px 5px;" }}
                    >
                      <div className="css-vurnku" style={{ color: "#00b897" }}>
                        Đăng ký
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </>
          )}
        </div>
        <div className="css-1smf7ma">
          <span>Việt Nam</span>
        </div>
      </ul>
    </header>
  );
});

export default HeaderDesktop;
